import React from "react"
import { Link } from "gatsby"

const RepairServiceFooterMenu = () => {
  return (
    <React.Fragment>
      <Link to="/electronic-repair-services">Electronic Repair</Link>
      <Link to="/mechanical-repair-services">Mechanical Repair</Link>
      <Link to="/servo-repair-services">Servo Repair</Link>
      <Link to="/hydraulic-repair-services">Hydraulic Repair</Link>
      <Link to="/kiosk-printer-repair-services">Kiosk & Printer Repair</Link>
    </React.Fragment>
  )
}

export default RepairServiceFooterMenu
